import React from 'react';

import { WidgetTableColumn } from 'jamespot-user-api';

import { EditorSelect } from 'components/Editors/components/EditorSelect';

import { EditorInput } from 'components/Editors/components/EditorInput';
import { useIntl } from 'react-intl';
import { CSSFlexInput, CSSInlineInput, CSSListBorderBottom } from '../../JRCWidgetDatasourceTableEditor.styles';

export const ExcelEditorModelColumn = ({
    column,
    onChange,
}: {
    column: WidgetTableColumn;
    onChange: (data: WidgetTableColumn) => void;
}) => {
    const intl = useIntl();

    return (
        <CSSInlineInput>
            <CSSFlexInput>
                <EditorInput
                    initialValue={column.label}
                    label={intl.formatMessage({ id: 'EXCEL_Editor_Column_Label' })}
                    onChange={(label) => onChange({ ...column, name: column.name, label })}
                />
            </CSSFlexInput>
            <CSSFlexInput>
                <EditorSelect<
                    'number' | 'uri' | 'title' | 'date' | 'text' | 'file' | 'select' | 'email' | 'url' | 'transient'
                >
                    label={intl.formatMessage({ id: 'EXCEL_Editor_Column_Type' })}
                    initialValue={column.type}
                    required={true}
                    options={[
                        { label: intl.formatMessage({ id: 'WIDGET_Table_Column_Type_Date' }), value: 'date' },
                        { label: intl.formatMessage({ id: 'WIDGET_Table_Column_Type_Text' }), value: 'text' },
                        { label: intl.formatMessage({ id: 'WIDGET_Table_Column_Type_Url' }), value: 'url' },
                        { label: intl.formatMessage({ id: 'WIDGET_Table_Column_Type_Number' }), value: 'number' },
                    ]}
                    onChange={(type) => onChange({ ...column, name: column.name, type })}
                />
            </CSSFlexInput>
            <CSSListBorderBottom />
        </CSSInlineInput>
    );
};
